import { render } from "./SellersTerminal.vue?vue&type=template&id=2aa77bb9&scoped=true"
import script from "./SellersTerminal.vue?vue&type=script&lang=js"
export * from "./SellersTerminal.vue?vue&type=script&lang=js"

import "./SellersTerminal.vue?vue&type=style&index=0&id=2aa77bb9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2aa77bb9"]])

export default __exports__